<template>
  <div class="flex align-items-center com-point-label">
    <point
      v-if="isLeft"
      :type="type"
      class="mr8"
    />
    <span class="com-point-label__text" :class="{'ellipsis': isEllipsis}">{{ name }}</span>
    <point
      v-if="!isLeft"
      :type="type"
      class="ml8 mr24"
    />
    <div class="flex-1 com-point-label__text">
      <slot />
    </div>
  </div>
</template>

<script>
import point from './point.vue';

export default {
  components: { point },
  props: {
    name: String,
    type: Number,
    isLeft: {
      type: Boolean,
      default: false
    },
    isEllipsis: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="scss" scoped>
  .com-point-label {
    &__text {
      font-size: 14px;
      font-weight: 400;
      color: #262626;
      line-height: 20px;
    }
    .ellipsis {
      max-width: 112px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      word-wrap: normal;
      word-break: normal;
    }
  }
</style>
